import script from "./StudySteps.vue?vue&type=script&setup=true&lang=js"
export * from "./StudySteps.vue?vue&type=script&setup=true&lang=js"

import "./StudySteps.vue?vue&type=style&index=0&id=e142ca14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e142ca14"]])

export default __exports__